<template>
  <!-- 不让 iframe 的触摸进入 Vant 锁页判断，保留内部滚动与背景锁定。 -->
  <div class="third-url" @touchmove.stop>
    <iframe id="modle_iframe" :src="thirdUrl" frameborder="0" scrolling="yes"></iframe>
  </div>
</template>
<script>
export default {
  name: 'ThirdAgreement',
  props: {
    thirdUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.third-url {
  width: 100%;
  height: 100% !important;
  border-radius: 0.12rem;
  background-color: #ebf3fd !important;
  overflow: hidden;
}
#modle_iframe {
  // 让 iframe 完整占满协议卡片，由内部页面滚动，避免包装层产生多余滚动范围。
  display: block;
  width: 100%;
  height: 100%;
}
</style>
